export const PORTAL_RETURN_STORAGE_KEY = 'cf_portal_return_url';
export const LEGACY_MEMBERSHIP_RETURN_STORAGE_KEY = 'cf_membership_return_url';

export const safePortalReturnUrl = value => {
  if (typeof value !== 'string') return '';

  const returnUrl = value.trim();
  const containsControlCharacter = Array.from(returnUrl).some(character => {
    const codePoint = character.charCodeAt(0);
    return codePoint < 32 || codePoint === 127;
  });
  if (
    !returnUrl.startsWith('/') ||
    returnUrl.startsWith('//') ||
    returnUrl.includes('\\') ||
    containsControlCharacter
  ) {
    return '';
  }

  return returnUrl;
};

export const getStoredPortalReturnUrl = () => {
  if (typeof window === 'undefined') return '';

  try {
    const stored =
      window.localStorage?.getItem(PORTAL_RETURN_STORAGE_KEY) ||
      window.localStorage?.getItem(LEGACY_MEMBERSHIP_RETURN_STORAGE_KEY) ||
      '';

    return safePortalReturnUrl(stored);
  } catch {
    // Storage can be blocked by browser privacy settings.
    return '';
  }
};

export const persistPortalReturnUrl = value => {
  if (typeof window === 'undefined') return;

  const returnUrl = safePortalReturnUrl(value);
  if (returnUrl) {
    try {
      window.localStorage?.setItem(PORTAL_RETURN_STORAGE_KEY, returnUrl);
    } catch {
      // Persisting a return URL is best effort and must not interrupt login.
    }
  }
};

export const clearPortalReturnUrl = () => {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage?.removeItem(PORTAL_RETURN_STORAGE_KEY);
    window.localStorage?.removeItem(LEGACY_MEMBERSHIP_RETURN_STORAGE_KEY);
  } catch {
    // Login must continue even when browser storage is unavailable.
  }
};
